export enum UserAdministrationType {
    Users = 'users',
    Groups = 'groups',
}
